import { Product } from '../types';

// ============================================
// HEAD LAMP & SENSOR HOLDERS
// ============================================

// HEAD LIGHT HOLDERS - 3 POLE
export const headLampSensorHolderProducts: Product[] = [
  {
    id: "headlamp-sensor-3p-f-5mm-1",
    name: "Head Lamp and Sensor 3 Pole Female - 5mm Wire",
    slug: "headlamp-sensor-3-pole-female-5mm-1",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor 3 pole female holder with 5mm deluxe wire.",
    partNumber: "SH0300001",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300001.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
  {
    id: "headlamp-sensor-3p-f-5mm-2",
    name: "Head Lamp and Sensor 3 Pole Female - 5mm Wire (Type 2)",
    slug: "headlamp-sensor-3-pole-female-5mm-2",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor 3 pole female holder with 5mm deluxe wire.",
    partNumber: "SH0300006",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300006.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
  {
    id: "headlamp-sensor-ceramic-3p-f",
    name: "Head Lamp and Sensor Ceramic 3 Pole Female",
    slug: "headlamp-sensor-ceramic-3-pole-female",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor ceramic 3 pole female holder with 5mm deluxe wire. Heat resistant ceramic holder.",
    partNumber: "SH0300009",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300009.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Holder Type": "Ceramic",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "ceramic", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder", "High Temperature"],
  },
  {
    id: "headlamp-sensor-bakelite-3p-f",
    name: "Head Lamp and Sensor Bakelite 3 Pole Female",
    slug: "headlamp-sensor-bakelite-3-pole-female",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor bakelite 3 pole female holder with 5mm deluxe wire. Heat resistant bakelite holder.",
    partNumber: "SH0300012",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300012.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Holder Type": "Bakelite",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "bakelite", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder", "Heat Resistant"],
  },
  {
    id: "headlamp-sensor-3p-f-5mm-3",
    name: "Head Lamp and Sensor 3 Pole Female - 5mm Wire (Type 3)",
    slug: "headlamp-sensor-3-pole-female-5mm-3",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor 3 pole female holder with 5mm deluxe wire.",
    partNumber: "SH0300015",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300015.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
  {
    id: "headlamp-sensor-covernet-3p-f",
    name: "Head Lamp and Sensor Covernet 3 Pole Female",
    slug: "headlamp-sensor-covernet-3-pole-female",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor Covernet 3 pole female holder with 5mm deluxe wire.",
    partNumber: "SH0300017",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300017.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Holder Type": "Covernet",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "covernet", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
  {
    id: "headlamp-sensor-melamine-3p-f",
    name: "Head Lamp and Sensor Melamine 3 Pole Female",
    slug: "headlamp-sensor-melamine-3-pole-female",
    category: "Head Lamp & Sensor Holders",
    subcategory: "Head Light Holders",
    description: "Head lamp and sensor Melamine 3 pole female holder with 5mm deluxe wire.",
    partNumber: "SH0300023",
    image: "/products/sensor-lamp-holders/headlight-holder/SH0300023.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Application": "Head Lamp and Sensor",
      "Holder Type": "Melamine",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["headlamp", "sensor", "melamine", "holder", "3-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
];

// JPT SENSOR HOLDERS & CONNECTORS
export const jptSensorProducts: Product[] = [
  {
    id: "jpt-thermo-switch-indica-2p-f",
    name: "Thermo Switch Tata Indica 2 Pole Female JPT",
    slug: "jpt-thermo-switch-tata-indica-2-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT thermo switch for Tata Indica 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH0300201",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300201.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Tata Indica Thermo Switch",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "thermo-switch", "indica", "2-pole", "female"],
    applications: ["Tata Indica", "Thermo Switch"],
  },
  {
    id: "jpt-injector-2p-f-4mm",
    name: "Injector 2 Pole Female JPT - 4mm Wire",
    slug: "jpt-injector-2-pole-female-4mm",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT injector 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH0300202",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300202.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Injector",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "injector", "2-pole", "female"],
    applications: ["Injector", "Fuel System"],
  },
  {
    id: "jpt-injector-al-2p-f",
    name: "Injector Ashok Leyland 2 Pole Female JPT",
    slug: "jpt-injector-al-2-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT injector for Ashok Leyland 2 pole female connector with special wire.",
    partNumber: "SH0300211",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300211.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Ashok Leyland Injector",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "injector", "ashok-leyland", "2-pole", "female"],
    applications: ["Ashok Leyland", "Injector"],
  },
  {
    id: "jpt-injector-2p-f-4mm-2",
    name: "Injector 2 Pole Female JPT - 4mm Wire (Type 2)",
    slug: "jpt-injector-2-pole-female-4mm-2",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT injector 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH0300212",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300212.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Injector",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "injector", "2-pole", "female"],
    applications: ["Injector"],
  },
  {
    id: "jpt-injector-2p-f-4mm-3",
    name: "Injector 2 Pole Female JPT - 4mm Wire (Type 3)",
    slug: "jpt-injector-2-pole-female-4mm-3",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT injector 2 pole female connector with 4mm deluxe wire.",
    partNumber: "SH0300213",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300213.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Injector",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "injector", "2-pole", "female"],
    applications: ["Injector"],
  },
  {
    id: "jpt-injector-tata-3p-f",
    name: "Injector Tata 3 Pole Female JPT",
    slug: "jpt-injector-tata-3-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT injector for Tata 3 pole female connector with special wire.",
    partNumber: "SH0300302",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300302.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Tata Injector",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "injector", "tata", "3-pole", "female"],
    applications: ["Tata Injector"],
  },
  {
    id: "jpt-distributor-santro-4p-f",
    name: "Distributor Santro 4 Pole Female JPT",
    slug: "jpt-distributor-santro-4-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT distributor for Santro 4 pole female connector with special wire.",
    partNumber: "SH0300402",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300402.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Santro Distributor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "distributor", "santro", "4-pole", "female"],
    applications: ["Santro Distributor"],
  },
  {
    id: "jpt-tata-ace-cng-4p-f",
    name: "Tata ACE CNG 4 Pole Female JPT",
    slug: "jpt-tata-ace-cng-4-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT connector for Tata ACE CNG 4 pole female with special wire.",
    partNumber: "SH0300403",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300403.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Tata ACE CNG",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "tata", "ace", "cng", "4-pole", "female"],
    applications: ["Tata ACE CNG"],
  },
  {
    id: "jpt-headlamp-sensor-5p-f",
    name: "Head Lamp and Sensor 5 Pole Female JPT",
    slug: "jpt-headlamp-sensor-5-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT head lamp and sensor 5 pole female connector with special wire.",
    partNumber: "SH0300502",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300502.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Application": "Head Lamp and Sensor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "headlamp", "5-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
  {
    id: "jpt-headlamp-sensor-2p-f",
    name: "Head Lamp and Sensor 2 Pole Female JPT",
    slug: "jpt-headlamp-sensor-2-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT head lamp and sensor 2 pole female connector with special wire.",
    partNumber: "SH0300602",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300602.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Application": "Head Lamp and Sensor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "headlamp", "2-pole", "female"],
    applications: ["Head Lamp", "Sensor Holder"],
  },
  {
    id: "jpt-injector-tata-ace-2p-f",
    name: "Injector Tata Ace 2 Pole Female JPT",
    slug: "jpt-injector-tata-ace-2-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT injector for Tata Ace 2 pole female connector with special wire.",
    partNumber: "SH0300201",
    image: "/products/sensor-lamp-holders/jpt-sensor/SH0300201.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Tata Ace Injector",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "injector", "tata", "ace", "2-pole", "female"],
    applications: ["Tata Ace Injector"],
  },
  {
    id: "jpt-corner-light-t10-2p-f",
    name: "Corner Light & T-10 Holder 2 Pole Female JPT",
    slug: "jpt-corner-light-t10-2-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT corner light & T-10 holder 2 pole female connector with special wire.",
    partNumber: "SH0310001",
    image: "/products/sensor-lamp-holders/bulb-holder/SH0310001.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Corner Light & T-10 Holder",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "corner-light", "t10-holder", "2-pole", "female"],
    applications: ["Corner Light", "T-10 Holder"],
  },
  {
    id: "jpt-tata-meter-t10-2p-f",
    name: "Tata Meter & T-10 Holder 2 Pole Female JPT",
    slug: "jpt-tata-meter-t10-2-pole-female",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT Tata meter & T-10 holder 2 pole female connector with special wire.",
    partNumber: "SH0310002",
    image: "/products/sensor-lamp-holders/bulb-holder/SH0310002.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "JPT Sensor",
      "Compatible": "Tata Meter & T-10 Holder",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jpt", "sensor", "tata", "meter", "t10-holder", "2-pole", "female"],
    applications: ["Tata Meter", "T-10 Holder"],
  },
  {
    id: "jpt-sensor-wire-12in-4mm-fevikwik",
    name: "Sensor Wire 12\" Long - 4mm Deluxe Wire with Fevikwik",
    slug: "jpt-sensor-wire-12in-4mm-fevikwik",
    category: "JPT Sensor Connectors",
    subcategory: "JPT Sensor Holders",
    description: "JPT sensor wire 12 inch long with 4mm deluxe wire and Fevikwik. Set of 10 pcs.",
    partNumber: "SH0310005",
    image: "/products/sensor-lamp-holders/bulb-holder/SH0310005.jpg",
    specifications: {
      "Type": "JPT Sensor Wire",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "12 inches",
      "Features": "With Fevikwik",
      "Packing": "Set of 10 Pcs",
    },
    tags: ["jpt", "sensor", "wire", "12-inch", "fevikwik"],
    applications: ["Sensor Wire Extension"],
  },
];

// SUPER SEALED CONNECTORS
export const superSealedConnectorProducts: Product[] = [
  {
    id: "super-sealed-tata-ace-maximo-1p-f",
    name: "Tata ACE/Mahindra Maximo 1 Pole Female - Super Sealed",
    slug: "super-sealed-tata-ace-maximo-1-pole-female",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata ACE, fog lamp, Mahindra Maximo 1 pole female super sealed connector with special wire.",
    partNumber: "SH0400101",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400101.jpg",
    featured: true,
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Female",
      "Type": "Super Sealed",
      "Compatible": "Tata ACE, Fog Lamp, Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "1-pole", "tata", "ace", "maximo", "fog-lamp", "female"],
    applications: ["Tata ACE", "Mahindra Maximo", "Fog Lamp"],
  },
  {
    id: "super-sealed-tata-ace-maximo-1p-m",
    name: "Tata ACE/Mahindra Maximo 1 Pole Male - Super Sealed",
    slug: "super-sealed-tata-ace-maximo-1-pole-male",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata ACE, Mahindra Maximo 1 pole male super sealed connector with special wire.",
    partNumber: "SH0400102",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400102.jpg",
    featured: true,
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Male",
      "Type": "Super Sealed",
      "Compatible": "Tata ACE, Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "1-pole", "tata", "ace", "maximo", "male"],
    applications: ["Tata ACE", "Mahindra Maximo"],
  },
  {
    id: "super-sealed-tata-ace-maximo-2p-f",
    name: "Tata ACE/Mahindra Maximo 2 Pole Female - Super Sealed",
    slug: "super-sealed-tata-ace-maximo-2-pole-female",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata ACE, fog lamp, Mahindra Maximo 2 pole female super sealed connector with special wire.",
    partNumber: "SH0400201",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400201.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Super Sealed",
      "Compatible": "Tata ACE, Fog Lamp, Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "2-pole", "tata", "ace", "maximo", "fog-lamp", "female"],
    applications: ["Tata ACE", "Mahindra Maximo", "Fog Lamp"],
  },
  {
    id: "super-sealed-tata-2p-m",
    name: "Tata 2 Pole Male - Super Sealed",
    slug: "super-sealed-tata-2-pole-male",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 2 pole male super sealed connector with special wire.",
    partNumber: "SH0400202",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400202.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "2-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-dsl-filter-swift-speedometer-3p-f",
    name: "DSL/Filter/Swift/Speedometer Ritz/Tata Ace 3 Pole Female - Super Sealed",
    slug: "super-sealed-dsl-filter-swift-speedometer-ritz-3-pole-female",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "DSL, filter, Swift, speedometer Ritz, Tata Ace 3 pole female super sealed connector with special wire.",
    partNumber: "SH0400301",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400301.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Super Sealed",
      "Compatible": "DSL, Filter, Swift, Speedometer Ritz, Tata Ace",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "3-pole", "dsl", "filter", "swift", "ritz", "tata-ace", "female"],
    applications: ["Tata Ace", "Swift", "Ritz", "Speedometer", "Filter"],
  },
  {
    id: "super-sealed-tata-3p-m",
    name: "Tata 3 Pole Male - Super Sealed",
    slug: "super-sealed-tata-3-pole-male",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 3 pole male super sealed connector with special wire.",
    partNumber: "SH0400302",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400302.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "3-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-tata-4p-f",
    name: "Tata 4 Pole Female - Super Sealed",
    slug: "super-sealed-tata-4-pole-female",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 4 pole female super sealed connector with special wire.",
    partNumber: "SH0400401",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400401.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "4-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-tata-4p-m",
    name: "Tata 4 Pole Male - Super Sealed",
    slug: "super-sealed-tata-4-pole-male",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 4 pole male super sealed connector with special wire.",
    partNumber: "SH0400402",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400402.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "4-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-tata-5p-f",
    name: "Tata 5 Pole Female - Super Sealed",
    slug: "super-sealed-tata-5-pole-female",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 5 pole female super sealed connector with special wire.",
    partNumber: "SH0400501",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400501.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "5-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-tata-5p-m",
    name: "Tata 5 Pole Male - Super Sealed",
    slug: "super-sealed-tata-5-pole-male",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 5 pole male super sealed connector with special wire.",
    partNumber: "SH0400502",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400502.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Male",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "5-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-tata-6p-f",
    name: "Tata 6 Pole Female - Super Sealed",
    slug: "super-sealed-tata-6-pole-female",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 6 pole female super sealed connector with special wire.",
    partNumber: "SH0400601",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400601.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "6-pole", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "super-sealed-tata-6p-m",
    name: "Tata 6 Pole Male - Super Sealed",
    slug: "super-sealed-tata-6-pole-male",
    category: "Super Sealed Connectors",
    subcategory: "Super Sealed",
    description: "Tata 6 pole male super sealed connector with special wire.",
    partNumber: "SH0400602",
    image: "/products/sensor-lamp-holders/super-sealed/SH0400602.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Male",
      "Type": "Super Sealed",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["super-sealed", "6-pole", "tata", "male"],
    applications: ["Tata Vehicles"],
  },
];

// SENSOR CONNECTORS (ADDITIONAL)
export const sensorConnectorProducts: Product[] = [
  {
    id: "sensor-conn-maximo-2p-f",
    name: "Mahindra Maximo 2 Pole Female - Sensor",
    slug: "sensor-maximo-2-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Mahindra Maximo 2 pole female sensor connector with special wire.",
    partNumber: "SH0410201",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410201.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "2-pole", "maximo", "female"],
    applications: ["Mahindra Maximo", "Sensor"],
  },
  {
    id: "sensor-conn-al-tata-2p-f",
    name: "Ashok Leyland & Tata 2 Pole Female - Sensor",
    slug: "sensor-al-tata-2-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Ashok Leyland & Tata 2 pole female sensor connector with special wire.",
    partNumber: "SH0410202",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410202.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "2-pole", "ashok-leyland", "tata", "female"],
    applications: ["Ashok Leyland", "Tata", "Sensor"],
  },
  {
    id: "sensor-conn-maximo-2p-f-2",
    name: "Mahindra Maximo 2 Pole Female - Sensor (Type 2)",
    slug: "sensor-maximo-2-pole-female-2",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Mahindra Maximo 2 pole female sensor connector with special wire.",
    partNumber: "SH0410203",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410203.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "2-pole", "maximo", "female"],
    applications: ["Mahindra Maximo", "Sensor"],
  },
  {
    id: "sensor-conn-map-sensor-2p-f",
    name: "Map Sensor 2 Pole Female",
    slug: "sensor-map-sensor-2-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Map sensor 2 pole female connector with special wire.",
    partNumber: "SH0410204",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410204.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Map Sensor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "2-pole", "map-sensor", "female"],
    applications: ["Map Sensor", "Engine Sensors"],
  },
  {
    id: "sensor-conn-maximo-3p-f",
    name: "Mahindra Maximo 3 Pole Female - Sensor",
    slug: "sensor-maximo-3-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Mahindra Maximo 3 pole female sensor connector with special wire.",
    partNumber: "SH0410301",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410301.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "3-pole", "maximo", "female"],
    applications: ["Mahindra Maximo", "Sensor"],
  },
  {
    id: "sensor-conn-maximo-al-3p-f-1",
    name: "Mahindra Maximo & Ashok Leyland 3 Pole Female - Sensor",
    slug: "sensor-maximo-al-3-pole-female-1",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Mahindra Maximo & Ashok Leyland 3 pole female sensor connector with special wire.",
    partNumber: "SH0410302",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410302.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Mahindra Maximo & Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "3-pole", "maximo", "ashok-leyland", "female"],
    applications: ["Mahindra Maximo", "Ashok Leyland", "Sensor"],
  },
  {
    id: "sensor-conn-maximo-al-3p-f-2",
    name: "Mahindra Maximo & Ashok Leyland 3 Pole Female - Sensor (Type 2)",
    slug: "sensor-maximo-al-3-pole-female-2",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Mahindra Maximo & Ashok Leyland 3 pole female sensor connector with special wire.",
    partNumber: "SH0410303",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410303.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Mahindra Maximo & Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "3-pole", "maximo", "ashok-leyland", "female"],
    applications: ["Mahindra Maximo", "Ashok Leyland", "Sensor"],
  },
  {
    id: "sensor-conn-al-tata-3p-f",
    name: "Ashok Leyland & Tata 3 Pole Female - Sensor",
    slug: "sensor-al-tata-3-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Ashok Leyland & Tata 3 pole female sensor connector with special wire.",
    partNumber: "SH0410304",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410304.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "3-pole", "ashok-leyland", "tata", "female"],
    applications: ["Ashok Leyland", "Tata", "Sensor"],
  },
  {
    id: "sensor-conn-map-sensor-4p-f",
    name: "Map Sensor 4 Pole Female",
    slug: "sensor-map-sensor-4-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Map sensor 4 pole female connector with special wire.",
    partNumber: "SH0410401",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410401.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Map Sensor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "4-pole", "map-sensor", "female"],
    applications: ["Map Sensor", "Engine Sensors"],
  },
  {
    id: "sensor-conn-al-tata-4p-f",
    name: "Ashok Leyland & Tata 4 Pole Female - Sensor",
    slug: "sensor-al-tata-4-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Ashok Leyland & Tata 4 pole female sensor connector with special wire.",
    partNumber: "SH0410402",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410402.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "4-pole", "ashok-leyland", "tata", "female"],
    applications: ["Ashok Leyland", "Tata", "Sensor"],
  },
  {
    id: "sensor-conn-al-5p-f-1",
    name: "Ashok Leyland 5 Pole Female - Sensor",
    slug: "sensor-al-5-pole-female-1",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Ashok Leyland 5 pole female sensor connector with special wire.",
    partNumber: "SH0410501",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410501.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "5-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland", "Sensor"],
  },
  {
    id: "sensor-conn-al-sensor-5p-f",
    name: "Ashok Leyland Sensor 5 Pole Female",
    slug: "sensor-al-sensor-5-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Ashok Leyland sensor 5 pole female connector with special wire.",
    partNumber: "SH0410502",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410502.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Ashok Leyland Sensor",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "5-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland", "Sensor"],
  },
  {
    id: "sensor-conn-tata-marcopolo-ace-paddle-6p-f",
    name: "Tata Marcopolo ACE Paddle 6 Pole Female - Sensor",
    slug: "sensor-tata-marcopolo-ace-paddle-6-pole-female",
    category: "Sensor Connectors",
    subcategory: "Sensor Connectors",
    description: "Tata Marcopolo ACE paddle 6 pole female sensor connector with special wire.",
    partNumber: "SH0410601",
    image: "/products/sensor-lamp-holders/sensor-holder/SH0410601.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Type": "Sensor Connector",
      "Compatible": "Tata Marcopolo ACE Paddle",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["sensor", "connector", "6-pole", "tata", "marcopolo", "ace", "paddle", "female"],
    applications: ["Tata Marcopolo ACE", "Paddle Sensor"],
  },
];

// SINGLE FUSE CONNECTORS
export const singleFuseConnectorProducts: Product[] = [
  {
    id: "single-fuse-mft-2p-f-4mm",
    name: "MFT 2 Pole Female Single Fuse - 4mm Wire",
    slug: "single-fuse-mft-2-pole-female-4mm",
    category: "Single Fuse Connectors",
    subcategory: "Single Fuse Holders",
    description: "MFT 2 pole female single fuse connector with 4mm deluxe wire. 6.4 (No. 18).",
    partNumber: "SH0500004",
    image: "/products/sensor-lamp-holders/single-fuse-connector/SH0500004.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Single Fuse Connector",
      "Fuse Size": "6.4 (No. 18)",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["single-fuse", "connector", "2-pole", "mft", "female"],
    applications: ["Single Fuse Connection"],
  },
  {
    id: "single-fuse-mft-2p-f-5mm",
    name: "MFT 2 Pole Female Single Fuse - 5mm Wire",
    slug: "single-fuse-mft-2-pole-female-5mm",
    category: "Single Fuse Connectors",
    subcategory: "Single Fuse Holders",
    description: "MFT 2 pole female single fuse connector with 5mm deluxe wire.",
    partNumber: "SH0500006",
    image: "/products/sensor-lamp-holders/single-fuse-connector/SH0500006.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Single Fuse Connector",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["single-fuse", "connector", "2-pole", "mft", "female"],
    applications: ["Single Fuse Connection"],
  },
  {
    id: "single-fuse-6-4-2p-f-6mm",
    name: "6.4 (No. 18) 2 Pole Female Single Fuse - 6mm Wire",
    slug: "single-fuse-6-4-2-pole-female-6mm",
    category: "Single Fuse Connectors",
    subcategory: "Single Fuse Holders",
    description: "6.4 (No. 18) 2 pole female single fuse connector with 6mm deluxe wire.",
    partNumber: "SH0500014",
    image: "/products/sensor-lamp-holders/single-fuse-connector/SH0500014.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Single Fuse Connector",
      "Fuse Size": "6.4 (No. 18)",
      "Wire Type": "6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["single-fuse", "connector", "2-pole", "female"],
    applications: ["Single Fuse Connection"],
  },
  {
    id: "single-fuse-mft-2p-f-6mm",
    name: "MFT 2 Pole Female Single Fuse - 6mm Wire",
    slug: "single-fuse-mft-2-pole-female-6mm",
    category: "Single Fuse Connectors",
    subcategory: "Single Fuse Holders",
    description: "MFT 2 pole female single fuse connector with 6mm deluxe wire.",
    partNumber: "SH0500015",
    image: "/products/sensor-lamp-holders/single-fuse-connector/SH0500015.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Single Fuse Connector",
      "Wire Type": "6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["single-fuse", "connector", "2-pole", "mft", "female"],
    applications: ["Single Fuse Connection"],
  },
  {
    id: "single-fuse-6-4-2p-f-4mm",
    name: "6.4 (No. 18) 2 Pole Female Single Fuse - 4mm Wire",
    slug: "single-fuse-6-4-2-pole-female-4mm",
    category: "Single Fuse Connectors",
    subcategory: "Single Fuse Holders",
    description: "6.4 (No. 18) 2 pole female single fuse connector with 4mm deluxe wire.",
    partNumber: "SH0500016",
    image: "/products/sensor-lamp-holders/single-fuse-connector/SH0500016.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Single Fuse Connector",
      "Fuse Size": "6.4 (No. 18)",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["single-fuse", "connector", "2-pole", "female"],
    applications: ["Single Fuse Connection"],
  },
];

// COMBINATION FUSE SET
export const combinationFuseSetProducts: Product[] = [
  {
    id: "combination-fuse-tata-207di-4-8-9p-f",
    name: "Tata 207 DI Combination Set - 4, 8 & 9 Pole Female",
    slug: "combination-fuse-tata-207di-4-8-9-pole-female",
    category: "Single Fuse Connectors",
    subcategory: "Combination Set",
    description: "Tata 207 DI combination set with 4 pole, 8 pole & 9 pole female connectors. Special wire.",
    partNumber: "SH0600004 / SH0600009 / SH0600008",
    featured: true,
    specifications: {
      "Poles": "4 Pole, 8 Pole & 9 Pole",
      "Gender": "Female",
      "Type": "Combination Fuse Set",
      "Compatible": "Tata 207 DI",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["combination-set", "fuse", "tata", "207di", "4-8-9-pole", "female"],
    applications: ["Tata 207 DI", "Fuse Combination"],
  },
];
